import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import LeaderboardPage from "../pages/leaderboard/page";
import RulesPage from "../pages/rules/page";
import LivePage from "../pages/live/page";
import StorePage from "../pages/store/page";
import ConnectPage from "../pages/connect/page";
import TeststorePage from "../pages/teststore/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/leaderboard", element: <LeaderboardPage /> },
  { path: "/rules", element: <RulesPage /> },
  { path: "/live", element: <LivePage /> },
  { path: "/store/*", element: <StorePage /> },
  { path: "/connect", element: <ConnectPage /> },
  { path: "/teststore/*", element: <TeststorePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
